import React from "react"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"
import { getCompetitionMenuPageUrl } from "utils/urls"
import cx from "classnames"
import Link from "next/link"

type Props = {
  selectedId: string
  competitionCalciocomSlug: string
}

const buttons = [
  {
    key: "generale",
    label: "Generale",
  },
  {
    key: "calendario-risultati",
    label: "Calendario e Risultati",
  },
  {
    key: "classifica",
    label: "Classifica",
  },
  {
    key: "statistiche-giocatori",
    label: "Statistiche Giocatori",
  },
  {
    key: "statistiche-squadre",
    label: "Statistiche Squadre",
  },
  {
    key: "squadre",
    label: "Squadre",
  },
  {
    key: "albo-oro",
    label: "Albo d'oro",
  },
]

function CompetitionMenu({ selectedId, competitionCalciocomSlug }: Props) {
  return (
    <div className={style.competitionMenuMainCard}>
      <Row className={style.container}>
        <div className={style.linksContainer}>
          {buttons.map(({ key, label }) => {
            const url = getCompetitionMenuPageUrl(competitionCalciocomSlug, key)
            return (
              <div key={key} className={cx(style.link, selectedId === key && style.active)}>
                <Link href={url}>
                  <a title={label}>{label}</a>
                </Link>
              </div>
            )
          })}
        </div>
      </Row>
    </div>
  )
}

export default CompetitionMenu
